"use strict";

exports.__esModule = true;
exports.resolveLinks = resolveLinks;
var _types = require("../../types");
const ACALA_SUB_SCAN = 'https://acala.subscan.io';
const KARURA_SUB_SCAN = 'https://karura.subscan.io';
function resolveLinks(chain, extrinsicHash, blockNumber) {
  if (chain !== _types.ChainType.ACALA && chain !== _types.ChainType.KARURA) {
    return {
      subscan: ''
    };
  }
  const subscanURL = chain === _types.ChainType.ACALA ? ACALA_SUB_SCAN : KARURA_SUB_SCAN;
  if (extrinsicHash) {
    return {
      subscan: `${subscanURL}/extrinsic/${extrinsicHash}`
    };
  }
  if (blockNumber) {
    return {
      subscan: `${subscanURL}/block/${blockNumber}`
    };
  }
  return {
    subscan: ''
  };
}